import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { LpgBrandBrandLogo, LpgBrandBrandClaim } from "@/icons";

import styles from "./GlobalFooter.scss";

const GlobalFooterImpressum = forwardRef(({ children }, ref) => (
  <div ref={ref} className={styles["footer-section"]}>
    <div className={styles["footer-brand"]}>
      <div style={{ width: "73px", height: "37px" }}>
        <LpgBrandBrandLogo focusable="false" />
      </div>
      <div style={{ width: "153px", height: "12px" }}>
        <LpgBrandBrandClaim focusable="false" />
      </div>
    </div>
    <div className={styles["footer-info-group"]}>
      <span className={styles["copyright-text"]}>
        © Telekom Deutschland GmbH
      </span>
      <div className={styles["footer-links"]}>{children}</div>
    </div>
  </div>
));

GlobalFooterImpressum.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

GlobalFooterImpressum.displayName = "GlobalFooter.Impressum";

export default GlobalFooterImpressum;
